import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInternetarchiveComponent } from './simple-icons-internetarchive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInternetarchiveComponent ],
    exports:      [ SimpleIconsInternetarchiveComponent ],
    bootstrap:    []
})
export class SimpleIconsInternetarchiveModule {}
